import ShareProjectModalContainer from './containers/ShareProjectModalContainer'

export default ShareProjectModalContainer
